<script setup lang="ts">
import { CLASS_ROOT } from '../constants'
import { computed } from 'vue'

export interface IDSKHeaderGestorButtonProps {
  modelValue: boolean
  dataTestId: string
}

const props = withDefaults(defineProps<IDSKHeaderGestorButtonProps>(), {
  modelValue: false,
  dataTestId: '',
})

const active = computed(() => props.modelValue)

defineEmits(['update:modelValue'])
</script>

<template>
  <button
    :class="[
      `${CLASS_ROOT}__brand-gestor-button`,
      {
        [`${CLASS_ROOT}__brand-gestor-button--active`]: active,
      },
    ]"
    :aria-label="active ? 'Skryť informácie o stránke' : 'Zobraziť informácie o stránke'"
    :aria-expanded="active"
    :data-test-id="dataTestId"
    @click="$emit('update:modelValue', !active)"
  >
    <slot />
    <span :class="`${CLASS_ROOT}__link-arrow`"></span>
  </button>
</template>
